/* eslint linebreak-style: ["error", "unix"] */

import useModalWithQueryParams from 'hooks/useModalWithQueryParams';
import { ModalQueryParams } from 'data/app';
import DesktopNavbarMenuButton from 'components/buttons/button-navbar-desktop-menu/desktop-navbar-menu-button';

export default function SignupMenu() {
  const {
    isOpen,
    handleOpen,
    handleClose,
  } = useModalWithQueryParams(ModalQueryParams.SIGN_UP);

  return (
    <DesktopNavbarMenuButton
      buttonLabel="Torna-te sócio"
      isActive={isOpen}
      handleOpen={handleOpen}
      handleClose={handleClose}
    />
  );
}
